<template>
    <span>
        <button type="button" class="btn btn-success" @click="showModal">
            {{ trans('menu_planner.macronutrient_report.name') }}
        </button>
        <view-loader :loading="loading">
            <div id="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 id="modalLabel">{{ trans('menu_planner.macronutrient_report.header') }}
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </h3>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label class="col-form-label">
                                    {{ trans('menu_planner.macronutrient_report.date_from') }}
                                </label>
                                <date-picker
                                    v-model="dateFrom"
                                    :time="false"
                                ></date-picker>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">
                                    {{ trans('menu_planner.macronutrient_report.date_to') }}
                                </label>
                                <date-picker
                                    v-model="dateTo"
                                    :time="false"
                                ></date-picker>
                            </div>
                            <div v-if="!isValid" class="error">
                                <span v-for="error in errors" :key="error.message">{{ error.message }}<br></span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="generate">
                                {{ trans('form.generate') }}
                            </button>
                            <button type="button" class="btn default" data-dismiss="modal">
                                {{ trans('form.cancel') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </view-loader>
    </span>
</template>

<script>
import datePicker from '@component/datePicker.vue'
import moment from 'moment/moment'
import DateHelper from '@js/helpers/dateHelper'
import ViewLoader from '@component/ViewLoader.vue'
import toastr from '@js/toastr'

export default {
  name: 'MacronutrientReport',
  components: {
    ViewLoader,
    datePicker
  },
  props: {
    brand: {
      type: [Number, String],
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      maxDaysRange: 7,
      loading: false
    }
  },
  computed: {
    selectedRange() {
      return moment(this.dateTo).diff(moment(this.dateFrom), 'days')
    },
    isValid() {
      return !this.errors.length > 0
    },
    errors() {
      const errors = []
      if (moment(this.dateTo) < moment(this.dateFrom)) {
        errors.push({ message: Translator.trans('form.errors.date_to_must_be_equal_greater') })
      }
      if (Math.abs(this.selectedRange) > this.maxDaysRange - 1) {
        errors.push({ message: Translator.trans('menu_planner.macronutrient_report.days_range_error') })
      }
      return errors
    },
    selectedBrandName() {
      const selectedBrand = this.brands.find(item => item.id === this.brand)
      return selectedBrand.symbol
    },
  },
  methods: {
    showModal() {
      $('#modal').modal()
    },
    generate() {
      if (!this.dateFrom || !this.dateTo) {
        const currentDate = DateHelper.format(new Date())
        this.dateFrom = this.dateFrom || currentDate
        this.dateTo = this.dateTo || currentDate
      }
      if (this.isValid) {
        const url = Routing.generate('ntfy_admin_app_planmenu_generate_macronutrient_report', {
          brand: this.brand,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo
        })

        this.showLoader(true)
        $('#modal').modal('hide')
        fetch(url).then(async (response) => {
          this.showLoader(false)
          if (response.ok) {
            const blob = await response.blob()
            this.saveFile(blob)
          } else {
            toastr.error(Translator.trans('menu_planner.macronutrient_report.no_data_error'))
          }
        })
      }
    },
    saveFile(blob) {
      let link = document.createElement('a')
      const filename = [
        Translator.trans('menu_planner.macronutrient_report.name'),
        this.selectedBrandName,
        this.dateFrom,
        this.dateTo,
      ].join('_')
      link.href = window.URL.createObjectURL(blob)
      document.body.appendChild(link)
      link.download = `${filename}.xlsx`
      link.click()
    },
    showLoader(value) {
      this.loading = value
    },
  },
}
</script>

<style scoped>
.error {
    color: red;
    margin-top: 20px;
}
</style>
